<template>
  <!-- 底部标签 -->
  <div class="bottom">
    <van-tabbar
      v-model="tabberIndex"
      active-color="#00706E"
      inactive-color="#000"
      @change="changeRoute"
    >
      <!-- <van-tabbar-item name="/index" icon="wap-home-o" @click="gotoIndex"
        >首页</van-tabbar-item
      > -->

      <van-tabbar-item name="/index" @click="gotoIndex">
        <span>首页</span>
        <template #icon="props">
          <img :src="props.active ? btnShouyelanNor: btnShouyeheiNor" />
        </template>
      </van-tabbar-item>

      <van-tabbar-item name="/xiaoyou" @click="gotoScenery">
        <span>母校风采</span>
        <template #icon="props">
          <img :src="props.active ? btnFengcailanNor : btnFengcaiheiNor" />
        </template>
      </van-tabbar-item>

      <van-tabbar-item name="/service" @click="gotoService">
        <span>服务大厅</span>
        <template #icon="props">
          <img :src="props.active ? btnDatingalanNor : btnDatingaNor" />
        </template>
      </van-tabbar-item>

      <!-- <van-tabbar-item name="/service" @click="gotoService" icon="apps-o"
        >服务大厅</van-tabbar-item> -->

      <van-tabbar-item name="/mine" @click="gotoMine">
        <span>个人中心</span>
        <template #icon="props">
          <img :src="props.active ? btnWodelanNor: btnWodeheiNor " />
        </template>
      </van-tabbar-item>

      <!-- <van-tabbar-item name="/mine" @click="gotoMine" icon="contact"
        >个人中心</van-tabbar-item> -->
    </van-tabbar>
  </div>
</template>

<script>
// import { ref } from 'vue';
import btnShouyeheiNor from "@/assets/image/btn_shouyehei_nor.png";
import btnShouyelanNor from "@/assets/image/btn_shouyelan_nor.png";
import btnDatingaNor from "@/assets/image/btn_datinga_nor.png";
import btnDatingalanNor from "@/assets/image/btn_datinga_nor(1).png";
import btnFengcaiheiNor from "@/assets/image/btn_fengcaihei_nor.png";
import btnFengcailanNor from "@/assets/image/btn_fengcailan_nor.png";
import btnWodeheiNor from "@/assets/image/btn_wodehei_nor.png";
import btnWodelanNor from "@/assets/image/btn_wodelan_nor.png";

export default {
  data() {
    return {
      tabberIndex: "/index",
      btnShouyeheiNor,
      btnShouyelanNor,
      btnDatingaNor,
      btnDatingalanNor,
      btnFengcaiheiNor,
      btnFengcailanNor,
      btnWodeheiNor,
      btnWodelanNor,
    };
  },
  moment() {
    this.$router.replace({ path: "/index" });
  },
  methods: {
    changeRoute(val) {
      console.log(val);
      this.$forceUpdate();
      if (val != "/xiaoyou") {
        this.$router.replace({ path: "/new-path" });
        this.$router.replace({ path: val });
      }
      this.tabberIndex = val;
    },
    gotoIndex() {
      return this.$router.push("/index");
    },
    gotoService() {
      return this.$router.push("/service");
    },
    gotoScenery() {
      return this.$router.push("/alumniHome");
      // window.location.href = "wx.dlmu.edu.cn/app/schoolfellow/schoolScenery";
    },
    gotoMine() {
      return this.$router.push("/mine");
    },
  },
};
</script>

<style scoped>
.bottom {
  height: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/tabbar.vue